import { createStore } from 'vuex'

export default createStore({
  state: {
    hasLogin: false,
    userInfo: {},
    products: [],
    tradePid: null,
    kf: localStorage.getItem('KF') || '',
    language: localStorage.getItem('language') || 'zh-TW'
  },
  mutations: {
    login(state, provider) {
      state.hasLogin = true
      state.userInfo = provider
      localStorage.setItem('userInfo', JSON.stringify(provider))
    },
    logout(state) {
      state.hasLogin = false
      state.userInfo = {}
      localStorage.removeItem('userInfo')
      localStorage.removeItem('uid')
    },
    setProducts(state, products) {
      state.products = products
    },
    setTradePid(state, pid) {
      state.tradePid = pid
    },
    setKf(state, kf) {
      state.kf = kf
      localStorage.setItem('KF', kf)
    },
    setLanguage(state, language) {
      state.language = language
      localStorage.setItem('language', language)
    }
  },
  actions: {
    login({ commit }, userInfo) {
      commit('login', userInfo)
    },
    logout({ commit }) {
      commit('logout')
    },
    setLanguage({ commit }, language) {
      commit('setLanguage', language)
    }
  },
  getters: {
    hasLogin: state => state.hasLogin,
    userInfo: state => state.userInfo,
    products: state => state.products,
    tradePid: state => state.tradePid,
    kf: state => state.kf,
    language: state => state.language
  }
})